import React from 'react'
import parkingLocationPagesEU from '../../../../config/parkingLocationPagesEU'
import ProductSelect from './productSelect.jsx'

const ParkingSelect = ({id, label = 'Flughafen auswählen'}) => (
  <ProductSelect id={id} label={label} options={parkingLocationPagesEU} />
)

export default ParkingSelect



// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/dropdowns/parkingselectEU.jsx